import React from 'react';
import ContactList from "../ContactList/ContactList";
import withSorting from "../../hocs/withSorting";
import {compose} from "redux";
import {formatDateTime} from "../../utils";
import PageHeader from "../PageHeader";
import {duckify, filterDuck} from "../../utils/duckify";
import {modals, userJobs as userJobsDuck} from "../../ducks";

const UserJobPage = ({dispatch, jobs, sort, onSort, deleteJob}) => {
  const report_urls = {
    'BillingAgingReportJob': '/admin/billing/aging',
    'RevenueRecognitionReportJob': '/admin/billing/revenue_recognition_report',
    'MonthlyIncrementalReportJob': '/admin/billing/monthly_incremental_report',
  }
  const columns = [
    {
      header: 'Job Type',
      sortName: 'type',
      type: 'name',
      value: (job) => <td>{job.job_display_name}{job.is_view_job ? ' - View' : ''}</td>
    },
    {
      header: 'Start Time',
      sortName: 'created_at',
      value: (job) => <td>{formatDateTime(job.created_at)}</td>
    },
    {
      header: 'Finish Time',
      sortName: 'finished_at',
      value: (job) => <td>{job.finished_at ? formatDateTime(job.finished_at) : ''}</td>
    },
    {
      header: 'Status',
      sortName: 'status',
      value: 'status'
    },
    {
      header: 'Result',
      value: (job) => {
        if (job.is_view_job === true && job.status === 'completed') {
          // Show "View" button for completed async report jobs
          return (
            <td>
              <a href={`${report_urls[job.type]}?job_id=${job.id}`}>View</a>
            </td>
          );
        } else if (job.has_attachment) {
          // Show "Download" button for jobs with attachments
          return (
            <td>
              <a href={`/api/user_jobs/${job.type}/${job.id}/attachment`}>Download</a>
            </td>
          );
        } else {
          return <td />;
        }
      }
    },
    {
      header: '',
      value: (job) => {
        return <td><a href='#' onClick={
          () => {
            dispatch(modals.actions.show('VerificationModal', {
              title: 'Delete Job',
              message: 'Are you sure you would like to delete this job? It will no longer be visible on this page.',
              onClose: () => {
                dispatch(modals.actions.hide());
              },
              onConfirm: () => deleteJob(job)
                .then(() => dispatch(userJobsDuck.actions.markDirty()))
                .catch(() => {
                  dispatch(modals.actions.show('UnexpectedError', {
                    onClose: () => {
                      dispatch(modals.actions.hide_all());
                    }
                  }));
                })
            }))
          }
        }>Delete</a></td>;
      }
    }
  ];

  return <React.Fragment>
    <div className='contact-list-react-page-title'>
      <PageHeader header='User Jobs' inline />
    </div>

    <ContactList
      columns={columns}
      contacts={jobs}
      emptyMessage='You have no User Jobs.'
      sort={sort}
      onSort={onSort}
    />
  </React.Fragment>;
};

const mapDucksToProps = ({ location }) => ({
  jobs: filterDuck(userJobsDuck, {sort: (location.search.match(/\?sort=(.*)/) || [])[1]})
});

const mapDispatchToProps = (dispatch) => ({
  deleteJob: (job) => dispatch(userJobsDuck.actions.remove(job))
});

export default compose(
  withSorting({ column: 'created_at', order: 'desc' }),
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(UserJobPage);
